import styled from 'styled-components'

const Div = styled.div`
  margin-top: 24px;
`

export { Div }
